import Api from "./base/api-base";

export default class ConstructionAggregateApi {

  info(date, id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.construction_aggregate, id: date},
        {endpoint: Api.endpoint.construction, id: id}
      ]
    });
  }
}
